import React, { useState, useEffect } from 'react';
import Constants from 'components/layout_and_quote_builder/Constants.jsx'

// The material sheet(s) are computed server-side from the section's templates and the fixed
// allowances (issue #5194, "Malzeme Tabakasi Bulma"). They are no longer chosen -- or shown -- on the
// page: the material sheet dimension dropdowns are hidden. This component keeps the (invisible) job of
// forwarding the computed layout_dimension_ids (which arrive in `defaultValues` from the
// default-material-values endpoint) and the solution-filtering toggle to the combinations request via
// publicSetter; only the filtering toggle is rendered.
const ChooseLayoutDimensions = ({ index, defaultValues, publicSetter }) => {
  const [layout_dimension_filtering_enabled, set_layout_dimension_filtering_enabled] = useState(false);

  const getPublicData = () => {
    return {
      ...defaultValues,
      layout_dimension_filtering_enabled,
    }
  }

  useEffect(() => {
    if (publicSetter != undefined) {
      publicSetter(() => getPublicData());
    }
    emitEvent(Constants.layout_dimension_changed, { index: index });
  }, [layout_dimension_filtering_enabled])

  return (<>
    <div>
      <table className="table table-bordered">
        <tbody>
          <tr>
            <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
              <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                <input
                  type="checkbox"
                  checked={layout_dimension_filtering_enabled}
                  onChange={(e) => set_layout_dimension_filtering_enabled(e.target.checked)}
                  style={{marginRight: '8px'}}
                />
                <span>{t('quote_builder.solution_filtering')}</span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{'clear': 'both'}}></div>
  </>)
}

export default ChooseLayoutDimensions;
